var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1231 0.563755V2.61233L12.5418 0L11.4276 1.11957L14.0168 3.73984H11.9847V5.32788H16.6924V0.563755H15.1231Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70769 13.2681V11.6801H1V16.4442H2.56923V14.3877L5.15062 17L6.26477 15.8804L3.67554 13.2681H5.70769Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3539 10.886H5.70775V6.1219C5.70775 5.70073 5.8731 5.29682 6.16739 4.99901C6.46167 4.70119 6.86079 4.53386 7.27698 4.53386H10.4154V2.15179C10.4154 1.73062 10.2501 1.32672 9.9558 1.0289C9.66151 0.731085 9.26239 0.563751 8.84621 0.563751H3.3539C2.93771 0.563751 2.5386 0.731085 2.24431 1.0289C1.95002 1.32672 1.78467 1.73062 1.78467 2.15179V9.29799C1.78467 9.71916 1.95002 10.1231 2.24431 10.4209C2.5386 10.7187 2.93771 10.886 3.3539 10.886Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3385 6.12189H8.84621C8.43002 6.12189 8.03091 6.28922 7.73662 6.58704C7.44233 6.88485 7.27698 7.28875 7.27698 7.70993V14.8561C7.27698 15.2773 7.44233 15.6812 7.73662 15.979C8.03091 16.2768 8.43002 16.4442 8.84621 16.4442H14.3385C14.7547 16.4442 15.1538 16.2768 15.4481 15.979C15.7424 15.6812 15.9077 15.2773 15.9077 14.8561V7.70993C15.9077 7.28875 15.7424 6.88485 15.4481 6.58704C15.1538 6.28922 14.7547 6.12189 14.3385 6.12189ZM8.84621 8.50395H11.9847V9.29797H8.84621V8.50395ZM14.3385 14.0621H8.84621V13.2681H14.3385V14.0621ZM14.3385 11.68H8.84621V10.886H14.3385V11.68Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6923,
    height: 17,
    fill: "white",
    transform: "translate(1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms);
export default __webpack_public_path__ + "static/media/Forms.c6c815ae.svg";
export { ForwardRef as ReactComponent };